import React, { useEffect } from "react";
import { SecureRoute } from "@okta/okta-react";
import { Helmet } from "react-helmet";
import {
  RouteProps as ReactRouterProps,
  Route as ReactRouterRoute,
  Redirect,
} from "react-router-dom";
import { isOktaEnabled } from "auth/utils/oktaAuth";
import { AUTH_TOKEN_KEY, LOGIN_PATHNAME } from "core/constants";

interface RouteProps extends ReactRouterProps {
  requireAuth?: boolean;
  title: string;
}

export const Route = ({ requireAuth, title, ...routeProps }: RouteProps) => {
  const pathname = routeProps.location && routeProps.location.pathname;
  useEffect(() => {
    window.analytics.page(title);
  }, [pathname]);

  // For Prod / OKTA Envs, we will defer to SecureRoute going forward.
  // This Redirect is preserved for legacy / dev purposes.
  if (requireAuth) {
    localStorage.setItem("originalPath", pathname || "");
    if (!isOktaEnabled && !localStorage.getItem(AUTH_TOKEN_KEY))
      return <Redirect to={LOGIN_PATHNAME} />;
  }

  const RouteComponent =
    isOktaEnabled && requireAuth ? SecureRoute : ReactRouterRoute;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <RouteComponent {...routeProps} />
    </>
  );
};
